import { createStore } from 'vuex'

export default createStore({
  state: {
    design_id:1,
    feedback_form_toggle:false,
    show_politic:false,
    design_data:[
    {id:3, img_logo:'head_1.svg', head_tittle:'Мы профессионально занимаемся всеми направлениями в сфере дизайна', head_desc:'Мы являемся экспертами в области дизайна и предлагаем полный спектр услуг, охватывающий все направления дизайнов, начиная от графического, промышленного и интерьерного дизайна, заканчивая веб-дизайном и разработкой брендинга.',
    cart:[
    {cart_tittle:'Graphic design', img_cart:'cart_back_1.svg', cart_desc:'Cоздание графических элементов, таких как логотипы, брендбуки, плакаты, баннеры, рекламные материалы и многое другое.'}, 
    {cart_tittle:'Web design', img_cart:'cart_back_2.svg', cart_desc:'Разработка дизайна для веб-сайтов, включая пользовательские интерфейсы, анимации и другие визуальные элементы.'}, 
    {cart_tittle:'UI|UX design', img_cart:'cart_back_3.svg', cart_desc:'Работа с элементами и стилем (UI) для мобильных приложений, программного обеспечения и других систем.'},
    ],
    finishProgect:[
    ],
    },
    {id:1, img_logo:'head_2.svg', head_tittle:'Мы разрабатываем инструменты для успешного развития бизнеса', head_desc:'Мы создаем эффективные корпоративные сайты, которые помогают нашим клиентам расширять свой бизнес и находить новых клиентов. Мы также разрабатываем креативные лэндинги, онлайн магазины и агрегаторы, которые станут визитной карточкой компании.',
    cart:[
    {cart_tittle:'Landing page', img_cart:'Landing_page.svg', cart_desc:'Специальная страница, предназначенная для привлечения клиентов и продвижения товаров или услуг.'}, 
    {cart_tittle:'Online Store', img_cart:'Online_Store.svg', cart_desc:'Сайт где пользователи могут просматривать каталог товаров, и заказывать нужные товары через интернет.'}, 
    {cart_tittle:'Aggregators', img_cart:'Agregators.svg', cart_desc:'Сайт, который собирает информацию или товары из разных источников, объединяет их и представляют в удобном виде.'},
    ],
    finishProgect:[
    ],
    },
    {id:2, img_logo:'head_3.svg', head_tittle:'Удобные и инновационные приложения для Android и iOS от нашей команды', head_desc:'Мы создаем приложения для Android и iOS, которые облегчают жизнь и предоставляют удобный доступ к информации. Наша команда специализируется на разработке инновационных и функциональных приложений для разных сфер жизни.', 
    cart:[
    {cart_tittle:'Promo Apps', img_cart:'Promo_Apps.svg', cart_desc:'Мобильные приложения, которые создаются для продвижения бренда или продукта, а не для коммерческой прибыли.'}, 
    {cart_tittle:'Content Apps', img_cart:'Content_Apps.svg', cart_desc:'Мы создаем разнообразные приложения для мобильных устройств и компьютеров, которые облегчают повседневную жизнь пользователей'}, 
    {cart_tittle:'Social media', img_cart:'UI_UX_design.svg', cart_desc:'Мы разрабатываем приложения для социальных сетей, которые помогают пользователям находить новых друзей, общаться.'},
    ],
    finishProgect:[
    ],
    },
    {id:4, img_logo:'head_4.svg', head_tittle:'Наша команда создает  ботов, которые упрощают жизнь и экономят время', head_desc:'Боты - это программа, которая может автоматически выполнять задачи в интернете. Они стали незаменимыми помощниками для многих пользователей, упрощая жизнь и экономя время.',
    cart:[
    {cart_tittle:'Chatbots', img_cart:'Chatbots.svg', cart_desc:'Программы, которые работают в мессенджерах и общаются с пользователем через текстовые сообщения.'}, 
    {cart_tittle:'Website bots', img_cart:'Online_Store.svg', cart_desc:'Программы, которые могут выполнять задачи, такие как обработка заказов или обращений от клиентов.'}, 
    {cart_tittle:'Game bots', img_cart:'UI_UX_design.svg', cart_desc:'Программы, которые создаются для игровых приложений и выполняют различные задачи.'},
    ],
    finishProgect:[
    ],
    },
    {id:5, img_logo:'head_5.svg', head_tittle:'Парсеры, позволяют сократить время и упростить работу в сборе данных', head_desc:'Парсеры являются незаменимым инструментом для сбора и анализа данных из различных источников в Интернете. Они позволяют извлекать информацию из веб-страниц, баз данных и других форматов данных',
    cart:[
    {cart_tittle:'Telegram', img_cart:'tg.svg', cart_desc:'Боты, которые работают в мессенджерах и общаются с пользователем через текстовые сообщения. '}, 
    {cart_tittle:'Instagram', img_cart:'inst.svg', cart_desc:'Боты, которые могут выполнять задачи, такие как обработка заказов или обращений от клиентов.'}, 
    {cart_tittle:'VK', img_cart:'vk.svg', cart_desc:'Боты, которые создаются для игровых приложений и выполняют различные задачи.'},
    ],
    finishProgect:[
    ],
    },
    {id:6, img_logo:'head_6.svg', head_tittle:'Разработка под ключ: современные технологии и производительность', head_desc:'Мы разрабатываем приложения, сайты и ботов под ключ для различных областей и сфер деятельности. Мы используем современные технологии и фреймворки для достижения высокой производительности и удобства использования',
    cart:[
    {cart_tittle:'Website', img_cart:'Landing_page.svg', cart_desc:'Мы можем разработать корпоративные сайты, лендинги, порталы, форумы и другие типы сайтов под ключ.'}, 
    {cart_tittle:'Apps', img_cart:'UI_UX_design.svg', cart_desc:'Мы можем разработать корпоративные сайты, лендинги, порталы, форумы и другие типы сайтов под ключ.'}, 
    {cart_tittle:'Bots', img_cart:'Chatbots.svg', cart_desc:'Программы, которые создаются для игровых приложений и выполняют различные задачи.'},
    ],
    finishProgect:[
    ],
    },
    ],
  },
    modules: {
  },
  mutations: {
    FEEDBACK_FORM(state){
    state.feedback_form_toggle = !state.feedback_form_toggle
    },
  },
  actions: {

  },
  getters: {
    DESIGN_DATA(state){
      let filter = state.design_data.filter(el => {if(el.id == state.design_id) return el})
      return filter[0]
    }
  }
})
